import { ContractFunctionResult } from "@eulerxyz/core-sdk"
import { BatchResultStatus } from "@eulerxyz/evc-sdk"
import type { Address, Hex } from "viem"
import {
  Asset,
  type TransactionItemBase,
  type TransactionItemUnion,
  TransactionLabel,
} from "./baseTransactionTypes"

export type SwapVerifierSkimMinTransaction = {
  label: TransactionLabel.SWAP_VERIFIER_SKIM_MIN
  subLabel?: string
  from: Address
  to: Address
  account: Address
  asset: Asset
  vault: Address
  amount: string
  deadline: string
  verifierAddress: Address
  verifierData: Hex
  result?: BatchResultStatus<ContractFunctionResult>
}

export function isSwapVerifierSkimMinTransactionItem(
  transaction?: TransactionItemUnion,
): transaction is SwapVerifierSkimMinTransaction {
  return transaction?.label === TransactionLabel.SWAP_VERIFIER_SKIM_MIN
}

export type SwapVerifierDebtMaxTransaction = {
  label: TransactionLabel.SWAP_VERIFIER_DEBT_MAX
  subLabel?: string
  from: Address
  to: Address
  account: Address
  asset: Asset
  vault: Address
  amount: string
  deadline: string
  verifierAddress: Address
  verifierData: Hex
  result?: BatchResultStatus<ContractFunctionResult>
}

export type SwapVerifierDebtMaxTransactionItem =
  TransactionItemBase<SwapVerifierDebtMaxTransaction>

export function isSwapVerifierDebtMaxTransactionItem(
  transaction?: TransactionItemUnion,
): transaction is SwapVerifierDebtMaxTransactionItem {
  return transaction?.label === TransactionLabel.SWAP_VERIFIER_DEBT_MAX
}

export type SwapVerifierTransaction =
  | SwapVerifierSkimMinTransaction
  | SwapVerifierDebtMaxTransaction
